<template>
  <div class="qr-scanner-home qr-template">
    <p class="error">{{ error }}</p>

    <p class="qr-text">Please scan a QR code</p>

    <div class='qr-container'>
      <qrcode-stream 
        @decode="onDecode" 
        @init="onInit" 
      />
    </div>

    <p class="enter-code">Or, enter the 6-character code here:</p>

    <div class='txt-location-code'>
      <DxTextBox
        ref="txtLocationCodeRef"
        :value.sync="locationCode"
        :show-clear-button="true"
        styling-mode="outlined"
      >      
        <DxRequiredRule message="You must enter a code"/>
      </DxTextBox>  
    </div>

    <DxButton
      text='Submit'
      type='default'
      @click='btnSubmitClick'
    />

    <!--<p class="decode-result">Last result: <b>{{ result }}</b></p>-->
  </div>
</template>

<script>

//import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import {QrcodeStream} from 'vue-qrcode-reader'
import QrCode from 'vue-qrcode'
import DxTextBox from "devextreme-vue/text-box";
import DxButton from "devextreme-vue/button";
import DxValidator, { DxRequiredRule } from "devextreme-vue/validator";
import DxValidationSummary from 'devextreme-vue/validation-summary';

export default {

  components: { 
    QrcodeStream,
    QrCode,
    DxTextBox,
    DxButton,
    DxValidator, DxRequiredRule,
    DxValidationSummary,
  },
  data () {
    return {
      result: '',
      error: '',
      locationCode: null,
    }
  },
  created(){

  },
  methods: {
    /*
      This runs when the QR Reader recognizes a QR code
    */
    onDecode (result) {  
      this.result = result
      var tableId = result;

      //AJT ToDo - Verify that the QR code was a URL

      //Navigate to the url, include the code for the table
      this.$router.push({
        path: "/contact-info",
        query: { tableId }
      });

    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    },
  
    btnSubmitClick(e){
      //Make sure a code is entered
      if (e.validationGroup.validate().isValid) 
      {
        //Navigate to the url, include the code for the table
        /*this.$router.push({  
          //path: '/contact-info/${code}',
          name: 'contact-info',
          params: {
                    locationCode: this.locationCode,
                  }
        });*/

        this.$router.push({ 
          name: 'contact-info',
          params: { 
            //Leave the accountName param in here even though it doesn't get used in the contact-info form.  
            //This resolves a really odd bug in Chrome (maybe all browsers) in which locationCode gets sent to the contact-info page, but it is "undefined" when it gets there.
            //Real weird 
            accountName: 'accountName',  
            locationCode: this.locationCode,
          } 
        })

      }
    }
  }
}
</script>

<style scoped>

.error {
  font-weight: bold;
  color: red;
}

.qr-scanner-home {
  padding:20px;
}

.decode-result,
.qr-template {
  text-align:center;
}

.txt-location-code{
  max-width: 200px;
  margin:auto;
  padding-bottom: 20px;
}

.qr-text{
  padding-bottom: 15px;
}

.enter-code{
  padding-bottom: 10px;
  padding-top: 10px;
}

/* Set the size of the QR Scanner and center it */
.qr-container{
  height:300px;
  width: 300px;
  margin: auto;
}

</style>
